import React, { useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import { AddCircleOutlineOutlined, DragIndicator, RemoveCircleOutlineOutlined } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import FormConfigActionDialog from '../dialogs/FormConfigActionDialog';
import { useFormContext } from '../FormContext';
import ConfigCard from './components/ConfigCard';
import ConfigHeader from './components/ConfigHeader';
import { ConfigList, ConfigListItem } from './components/ConfigList';
const StyledConfigListItem = styled(ConfigListItem) `
  .plugin-display {
    padding-left: 22px;
  }
`;
export const FormConfigActions = ({ element, section }) => {
    var _a, _b;
    if (!element && !section) {
        throw new Error('element or section prop required.');
    }
    const { formState, actionPlugins, addSectionAction, updateSectionAction, moveSectionAction, deleteSectionAction, addElementAction, updateElementAction, moveElementAction, deleteElementAction } = useFormContext();
    const [editAction, setEditAction] = useState();
    let actions;
    if (element) {
        actions = ((_a = formState.selectedFormElement) === null || _a === void 0 ? void 0 : _a.actions) || [];
    }
    else {
        actions = ((_b = formState.selectedStateNode) === null || _b === void 0 ? void 0 : _b.onEntry) || [];
    }
    return (React.createElement(ConfigCard, null,
        React.createElement(ConfigHeader, { end: React.createElement(IconButton, { size: 'small', onClick: () => setEditAction(null) },
                React.createElement(AddCircleOutlineOutlined, null)) }, "Actions"),
        React.createElement(DragDropContext, { onDragEnd: result => {
                const { source, destination } = result;
                // dropped outside the list
                if (!destination) {
                    return;
                }
                if (element) {
                    moveElementAction(source.index, destination.index);
                }
                else {
                    moveSectionAction(source.index, destination.index);
                }
            } },
            React.createElement(Droppable, { droppableId: 'action' }, provided => (React.createElement(ConfigList, { className: 'action-list', ref: provided.innerRef },
                actions.map((action, index) => {
                    const plugin = actionPlugins.find(plugin => plugin.type === action.type);
                    return (React.createElement(Draggable, { key: index, index: index, draggableId: `draggable-${index}` }, (provided, snapshot) => (React.createElement(StyledConfigListItem, Object.assign({ hover: true, className: snapshot.isDragging ? 'dragging' : '', ref: provided.innerRef, icon: React.createElement(DragIndicator, null), iconProps: provided.dragHandleProps }, provided.draggableProps, { primary: action.type, secondaryAction: React.createElement(IconButton, { size: 'small', onClick: e => {
                                e.stopPropagation();
                                if (element) {
                                    deleteElementAction(index);
                                }
                                else {
                                    deleteSectionAction(index);
                                }
                            } },
                            React.createElement(RemoveCircleOutlineOutlined, null)), onClick: () => setEditAction(action) }),
                        React.createElement("div", { className: 'plugin-display' }, plugin ? (React.createElement(plugin.display, { action: action })) : (React.createElement(Alert, { severity: 'error' },
                            "Action \"",
                            action.type,
                            "\" plugin not found.")))))));
                }),
                provided.placeholder)))),
        (editAction || editAction === null) && (React.createElement(FormConfigActionDialog, { action: editAction, open: Boolean(editAction || editAction === null), onCancel: () => setEditAction(undefined), onChange: action => {
                setEditAction(undefined);
                if (editAction) {
                    const index = actions.indexOf(editAction);
                    if (element) {
                        updateElementAction(index, action);
                    }
                    else {
                        updateSectionAction(index, action);
                    }
                }
                else {
                    if (element) {
                        addElementAction(action);
                    }
                    else {
                        addSectionAction(action);
                    }
                }
            } }))));
};
export default FormConfigActions;
//# sourceMappingURL=FormConfigActions.js.map